import Pencil from 'svg/Pencil';
import { ButtonText } from 'components/Button';
import classNames from 'styles/utils/classNames';

interface EditButtonProps {
  onClick: () => void;
  className?: string;
  icon?: React.ReactNode;
}

const EditButton: React.FC<EditButtonProps> = ({ onClick, className, icon }) => {
  return (
    <ButtonText
      onClick={onClick}
      className={classNames(
        'grid h-10 w-10 place-items-center rounded-full bg-color-bg-lightmode-primary shadow-[0px_4px_20px_0px_rgba(0,0,0,0.16)] dark:bg-color-bg-darkmode-primary',
        className,
      )}
    >
      {icon || <Pencil className="h-4 w-4" />}
    </ButtonText>
  );
};

export default EditButton;
